import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sortLabel: {
    id: 'app.containers.Chatbot.ChatbotFeedback.sortLabel',
    defaultMessage: `Sort By`,
  },
});
